import { v2Colors } from "../../../tokens/color";
import { fontWeights } from "../../../tokens/typography";
import { formControlStyles, defaultColor, formControlFontSizeStyles } from '../formControlStyles';
export const selectStyles = Object.assign(Object.assign({}, formControlStyles), { removeCheckbox: {
        '& .MuiCheckbox-root': {
            display: 'none',
        },
    }, menuItem: Object.assign(Object.assign({}, formControlFontSizeStyles), { color: v2Colors.core.blackTarr, '&:hover': {
            backgroundColor: v2Colors.core.cloud,
            color: v2Colors.core.blackTarr,
        }, '&.Mui-selected': {
            backgroundColor: v2Colors.core.cloud,
            color: v2Colors.core.blackTarr,
        }, '& .MuiCheckbox-root': {
            display: 'inline-flex',
        } }), nativeHiddenPlaceholder: {
        '& > .MuiNativeSelect-select': {
            color: 'transparent !important',
        },
    }, nativeOption: {
        color: v2Colors.core.blackTarr,
    }, selectIcon: (color = defaultColor) => ({
        width: '1.6rem',
        height: '1.6rem',
        '& path': {
            fill: color,
        },
    }), groupHeading: Object.assign(Object.assign({}, formControlFontSizeStyles), { color: v2Colors.core.deepSpace, fontWeight: fontWeights.bold }) });
